import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DocumentConstants from 'constants/documents';
import i18n from 'i18n-js';

const useStyles = makeStyles((theme) => ({
  versionStatus: {
    height: 8,
    width: 8,
    marginRight: 6,
    borderRadius: 16,
    display: 'inline-block',
    backgroundColor: (props) => {
      if (typeof props.status !== 'string') {
        return;
      }
      const status = props.status.toLowerCase();
      return theme.palette.documents[status];
    },
  },
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    whiteSpace: 'nowrap',
  },
}));

function VersionStatus(props) {
  const classes = useStyles(props);
  return (
    <Box className={classes.wrapper} fontSize={props.fontSize} lineHeight={1}>
      {props.status !== 'NONE' && <span className={classes.versionStatus} />}
      <span>{i18n.t(`documents.${props.status}`.toLocaleLowerCase()) || props.defaultMessage}</span>
    </Box>
  );
}

VersionStatus.propTypes = {
  fontSize: PropTypes.number,
  /**
   * Current version status
   */
  status: PropTypes.oneOf(DocumentConstants.statuses),
};

VersionStatus.defaultProps = {
  fontSize: 14,
  status: undefined,
};

export default VersionStatus;
